import Vue from 'vue';

const log = function (object){
    let currentUrl = window.location.href
    console.log("┏━━━━━ 打印开始 Url: " + currentUrl + " ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━")
    let jsonStr = JSON.stringify(object,null,2);
    //创建新数组，存放数据及样式
    let arr=[''];
    //给每一个黑字设置样式
    arr[0]+='%c'+ jsonStr;
    //用随机函数生成三位数代表rgb颜色
    var random = randomFunc();
    arr[1]='color:#fff;font-size:15px;background-color:#'+random;
    //arr[1]='font-size:15px;color:#'+random;
    console.log.apply(console,arr)
    console.log("┗━━━━━ 打印结束 Url: " + currentUrl + " ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━")
    return false;
}

let randomFunc = function(){
    let random = Math.random().toFixed(3)*1000;
    if(random <= 100){
        return randomFunc();
    }else{
        return random;
    }
}

// 添加到 Vue原型链
// 临时调试方法
Vue.prototype.$debugger = log




// WEBPACK FOOTER //
// ./src/utils/debugger.js